import {take, call, put, fork} from 'redux-saga/effects'
import {GET_EXPORTED_FILE, GET_EXPORTED_FILE_TEMPLATE} from 'actions/get-exported-file/constants'
import {getProfile} from 'sagas/api/profile'
import {getOutletById} from 'sagas/api/outlets'
import * as actNotif from 'actions/notifications'
import * as act from 'actions/index'

function wait (millis) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, millis)
  })
}

export function * getExportedFile () {
  // noinspection InfiniteLoopJS
  while (true) {
    let request = yield take(GET_EXPORTED_FILE)
    yield put(act.sendingRequest(true))
    yield put(act.showLoadingSpinner(true))
    let {filename, outletId, currentPage} = request.payload
    let stop = false
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000)
      let outlet = yield call(getOutletById, outletId)
      if (!outlet.exporting) {
        let profile = yield call(getProfile)
        let pattern = new RegExp(filename, 'i')
        if (!pattern.test(profile.export_items_file)) {
          yield put(actNotif.error('Failed to export report ' + currentPage))
        } else {
          window.location.href = profile.export_items_file
        }
        stop = true
      }
    }

    yield put(act.sendingRequest(false))
    yield put(act.showLoadingSpinner(false))
  }
}

export function * getExportedWithoutOutlet () {
  // noinspection InfiniteLoopJS
  while (true) {
    let request = yield take(GET_EXPORTED_FILE_TEMPLATE)
    yield put(act.sendingRequest(true))
    yield put(act.showLoadingSpinner(true))
    let {filename} = request.payload
    let stop = false
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000)
      let profile = yield call(getProfile)
      if (profile.exporting === false) {
        let pattern = new RegExp(filename, 'i')
        if (!pattern.test(profile.export_items_file)) {
          yield put(actNotif.error('Failed to download file '))
        } else {
          window.location.href = profile.export_items_file
        }
        stop = true
      }
    }
    yield put(act.sendingRequest(false))
    yield put(act.showLoadingSpinner(false))
  }
}

export default function * getExportedFileSaga () {
  yield fork(getExportedFile)
  yield fork(getExportedWithoutOutlet)
}



// WEBPACK FOOTER //
// ./app/sagas/get-exported-file.js